import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "noCatalogue"]

  connect() {
    this.form = this.element.closest("form")
    this.boundEnableSummaryBeforeSubmit = () => { this.summaryTarget.disabled = false }
    this.form?.addEventListener("submit", this.boundEnableSummaryBeforeSubmit)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.boundEnableSummaryBeforeSubmit)
  }

  tryChangeSummary() {
    if (this.noCatalogueTarget.checked) {
      this.summaryTarget.checked = true
    }
  }

  changeNoCatalogue() {
    this.summaryTarget.checked = this.noCatalogueTarget.checked
    this.summaryTarget.disabled = this.noCatalogueTarget.checked
  }
}
